import type { Ref } from 'vue'

const registry: { [key: symbol]: boolean } = {}

export function usePreventBodyScroll({ shouldStopScroll }: { shouldStopScroll: Ref<boolean> }) {
  if (process.client) return

  const key = Symbol()
  registry[key] = false

  watch(
    shouldStopScroll,
    () => {
      if (!document.body) return

      if (shouldStopScroll.value) {
        registry[key] = true
        document.body.style.overflow = 'hidden'
      } else {
        registry[key] = false

        const setToTrueComponent = Object.getOwnPropertySymbols(registry).find(key => registry[key])

        if (!setToTrueComponent) {
          document.body.style.overflow = ''
        }
      }
    },
    { immediate: true }
  )

  onUnmounted(() => {
    delete registry[key]

    if (document.body) {
      const setToTrueComponent = Object.getOwnPropertySymbols(registry).find(key => registry[key])

      if (!setToTrueComponent) {
        document.body.style.overflow = ''
      }
    }
  })
}
